import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Plus = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M10 0c1.15 0 2.083.933 2.083 2.083v5.834h5.834a2.083 2.083 0 1 1 0 4.166h-5.834v5.834a2.083 2.083 0 1 1-4.166 0v-5.834H2.083a2.083 2.083 0 1 1 0-4.166h5.834V2.083C7.917.933 8.849 0 10 0" }) }));
});
Plus.displayName = 'Plus';
Plus.__iconComponentType = 'standard';
export default Plus;
//# sourceMappingURL=Plus.js.map